import React from 'react';
import './PartySummary.css';
import MenuItemCardImage from '../image/food-img.png';
import { FaMale } from "react-icons/fa";
import { FaFemale } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { Menu } from 'antd';
import MenuItemCard from './MenuItemCard';


export default function PartySummary({ selectedItems }) {
  return (
    <div className="summary-card">
      <div className="summary-header">
        <h3>Party Summary</h3>
      </div>
      <div className="summary-info">
        <img src={MenuItemCardImage} alt="Party" />
        <div className='summary-info-text'>
          <h4>Pure Vegetarian Food Party</h4>
          <p>Veggies Garden Palace</p>
          <div className='summary-info-time'>
            <p>DLP Phase 3, Gurugram - 122010</p>
            <p>Date: 14 April 2025</p>
            <p>Time Slot: 10PM - 1AM</p>
          </div>
        </div>
      </div>
      <div className="summary-contact">
        <div>
          <h4>Number of Guests</h4>
          <p><FaMale className='summary-contact-icon' /> Male: 2</p>
          <p><FaFemale className='summary-contact-icon' /> Female: 2</p>
        </div>
        <div>
          <h4>Registered Contact Details</h4>
          <p><FaPhoneAlt className='summary-contact-icon' /> +91 8767676758</p>
          <p><CiMail className='summary-contact-icon' /> aryan123@gmail.com</p>
        </div>
      </div>

      <div className="summary-menu">
        <h4>Selected Menu:</h4>
        <ul>
          {selectedItems.map((item) => (
            <MenuItemCard key={item.id} item={item} disabled={true} onToggle={() => { }} hideCheckbox={true} />
          ))}
          {selectedItems.length === 0 && <p>No items selected.</p>}
        </ul>
      </div>
    </div>
  );
}
